<template>
  <div class="contentful-responsive-asset" v-if="data" :class="{ bleedout: data.fullWidth, 'to-edge': data.fullWidth }">
    <suspense>
      <ContentfulAsset 
        v-bind="data.mobileAsset" 
        :lazy="!data.prefetch" 
        class="ctf-asset-mobile" 
        :isHibernated="!isMobile"
        :link="data.interaction === 'link' ? data.link :''"
        :link-target="hrefTarget"
        :productTags="data.interaction === 'product-tag' ? data.mobileAssetProducts : null"
        :videoPosterUrl="videoPosterUrl"
        :autoplayVideo="data.autoplayVideo"
      >
        <template v-slot:description-override>
          <slot name="description-override"></slot>
        </template>
      </ContentfulAsset>
    </suspense>
    <suspense>
      <ContentfulAsset 
        v-bind="data.desktopAsset" 
        :lazy="!data.prefetch" 
        class="ctf-asset-desktop" 
        :isHibernated="isMobile"
        :link="data.interaction === 'link' ? data.link :''"
        :link-target="hrefTarget"
        :productTags="data.interaction === 'product-tag' ? data.desktopAssetProducts : null"
        :videoPosterUrl="videoPosterUrl"
        :autoplayVideo="data.autoplayVideo"
        >
          <template v-slot:description-override>
            <slot name="description-override"></slot>
          </template>
      </ContentfulAsset>
    </suspense>
  </div>
</template>

<script>
import { useContentful, contentfulProps } from '@/compositions/useContentful.js';
import useResize from '@/compositions/useResize.js';
import ContentfulAsset from '../Fields/ContentfulAsset.vue';
import useAsyncComputed from '@/compositions/useAsyncComputed.js';
import { computed } from 'vue';
import UrlUtils from '@/pixel/utils/UrlUtils';

export default {
  components: {
    ContentfulAsset,
  },
  props: {
    ...contentfulProps,
    lazy: {
      type: Boolean,
      default: true,
    },
  },
  async setup(p, c) {
    const { width, isMobile } = useResize();

    const { data, init, resolveEntry} = useContentful('pageComponentResponsiveAsset', p, c);


    const [videoPosterUrl, loadVideoPosterUrl, initVideoPosterUrl] = useAsyncComputed(
      async () => (await resolveEntry(data.value?.videoPoster)?.fields?.file.url)
    );

    const hrefTarget = computed(() => {
      if (data.value?.openLinkNewTab !== null && typeof data.value?.openLinkNewTab !== 'undefined') {
        return data.value?.openLinkNewTab ? '_blank' : '_self';
      } else {
        if (data.value?.link !== null && typeof data.value?.link !== 'undefined') {
          return UrlUtils.isStorefrontUrl(data.value?.link) ? '_self' : '_blank';
        } else {
          return '_self';
        }
      }
    });


    await Promise.all([init, initVideoPosterUrl]);
    return { data, hrefTarget, isMobile, videoPosterUrl,width };
  },
};
</script>

<style lang="postcss">
@import '@/pixel/style/variables';

.contentful-responsive-asset {
  .description {
    font-size: var(--font-size-12);
    line-height: 1.2em;
    color: var(--grey-medium);
    text-align: center;
    white-space: pre-wrap;
    max-width: 400px;
    margin: auto;
    margin-top: var(--space-2);
    padding: 0 var(--space-4);
  }

  @media (max-width: calc($mobile-breakpoint - 1px)) {
    .ctf-asset-mobile {
      display: block;
    }
    .ctf-asset-desktop {
      display: none;
    }
  }
  @media (min-width: $mobile-breakpoint) {
    .ctf-asset-mobile {
      display: none;
    }
    .ctf-asset-desktop {
      display: block;
    }
  }
}
</style>
